import {
  GET_COMBO_STORE,
  GET_COMBO_STORE_SUCCESS,
  GET_COMBO_STORE_FAILURE,
} from "./actionTypes";

export const getComboStore = (dataSearch) => ({
  type: GET_COMBO_STORE,
  dataSearch,
});

export const getComboStoreSuccess = (data) => ({
  type: GET_COMBO_STORE_SUCCESS,
  payload: data,
});

export const getComboStoreFailure = () => ({
  type: GET_COMBO_STORE_FAILURE,
});
